export const data = [
 {
    id: 37,
    cover:
      "https://aleksandrachirtoska.com/img/projects/platinum-fine-wine-au.webp",
    title: "Platinum Fine Wine",
    categories: "Wordpress",
    liveUrl: "https://www.platinumfinewine.com.au/",
    // githubUrl: "",
    technology: ["Wordpress", "UX/UI","CSS3", "Elementor"],
    date: "January 2025",
    description:
      "The website was developed in Wordpress using Woocommerce with custom UX/UI design for a Australian company Platinum Fine Wine. It's a online store for selling international wines only for Australian market.",
    responsive: true,
  },
  {
    id: 36,
    cover:
      "https://aleksandrachirtoska.com/img/projects/bloomsbury-square-employment-law-uk.webp",
    title: "Bloomsbury Square Employment Law",
    categories: "Wordpress",
    liveUrl: "https://bsquarelaw.co.uk/",
    // githubUrl: "",
    technology: ["Wordpress", "CSS3", "Elementor"],
    date: "May 2024",
    description:
      "This is project is developed for a UK Employment Law firm. The website was developed with Astra Pro Wordpress Theme and Elementor Pro page builder",
    responsive: true,
  },
    {
    id: 35,
    cover: "https://aleksandrachirtoska.com/img/projects/elmigo.webp",
    title: "Elmigo",
    categories: "Wordpress",
    liveUrl: "https://elmigo.mk/",
    // githubUrl: "",
    technology: ["Wordpress", "CSS3", "Elementor"],
    date: "Feb 2024",
    description:
      "I was part of the Web Development Team at the company I work for. My part was the whole Front-End development. We were developing this project from Figma design that was created from creative team of UX/UI designers",
    responsive: true,
  },
  {
    id: 34,
    cover: "https://aleksandrachirtoska.com/img/projects/isos-mk.webp",
    title: "Institute of Accountants and Chartered Accountants of the Republic of Macedonia (ISOS)",
    categories: "Wordpress",
    liveUrl: "https://www.isos.mk/",
    // githubUrl: "",
    technology: ["Wordpress", "CSS3", "Elementor"],
    date: "Dec 2023",
    description:
      "I was part of the Web Development Team at the company I work for. My part was the whole Front-End development. We were developing this project from Figma design that was created from creative team of UX/UI designers",
    responsive: true,
  },
  {
    id: 33,
    cover: "https://aleksandrachirtoska.com/img/projects/mega-akustik.webp",
    title: "Mega Akustik",
    categories: "Wordpress",
    liveUrl: "https://megaakustik.mk/",
    // githubUrl: "",
    technology: ["Wordpress", "CSS3", "Elementor"],
    date: "Dec 2023",
    description:
      "I was part of the Web Development Team at the company I work for. My part was the whole Front-End development. We were developing this project from Figma design that was created from creative team of UX/UI designers",
    responsive: true,
  },
  {
    id: 32,
    cover: "https://aleksandrachirtoska.com/img/projects/gley-tv-mk-2023.webp",
    title: "Gley TV",
    categories: "Wordpress",
    liveUrl: "https://gley.dweb.mk/",
    // githubUrl: "",
    technology: ["Wordpress", "CSS3", "Divi"],
    date: "Oct 2023",
    description:
      "I was part of the Web Development Team at the company I work for. My part was the whole Front-End development. We were developing this project from Figma design that was created from creative team of UX/UI designers",
    responsive: true,
  },
  {
    id: 31,
    cover: "https://aleksandrachirtoska.com/img/projects/tastify-mk-2023.webp",
    title: "Tastify",
    categories: "Wordpress",
    liveUrl: "https://tastify.mk/",
    // githubUrl: "",
    technology: ["Wordpress", "CSS3", "Divi"],
    date: "Sep 2023",
    description:
      "I was part of the Web Development Team at the company I work for. My part was the whole Front-End development. We were developing this project from Figma design that was created from creative team of UX/UI designers",
    responsive: true,
  },

  {
    id: 30,
    cover: "https://aleksandrachirtoska.com/img/projects/zoo-skopje-2023.webp",
    title: "ZOO Skopje",
    categories: "Wordpress",
    liveUrl: "https://zooskopje.com.mk/",
    // githubUrl: "",
    technology: ["Wordpress", "CSS3", "Divi"],
    date: "May 2023",
    description:
      "I was part of the Web Development Team at the company I work for. My part was the whole Front-End development. We were developing this project from Figma design that was created from creative team of UX/UI designers",
    responsive: true,
  },
   {
    id: 29,
    cover:
      "https://aleksandrachirtoska.com/img/projects/Izvidnici-Prilep-Feniks.webp",
    title: "Scouts Prilep",
    categories: "Wordpress",
    liveUrl: "https://www.izvidniciprilep.org/",
    // githubUrl: "",
    technology: ["Wordpress", "CSS3", "Elementor"],
    date: "May 2024",
    description:
      "This is project is my contribution to a local scout organization. The website was developed with Vedhak Wordpress Theme and Elementor page builder",
    responsive: true,
  },
  {
    id: 28,
    cover: "https://aleksandrachirtoska.com/img/projects/royalkidshouse.webp",
    title: "Royal Kids House",
    categories: "Wordpress",
    liveUrl: "https://www.royalkidshouse.com/",
    // githubUrl: "",
    technology: ["Wordpress", "CSS3", "Elementor"],
    date: "Feb 2024",
    description:
      "This is my favourite project. It's for a local day care private school Royal Kods House. The website was developed with Skole Wordpress Theme and Elementor page builder",
    responsive: true,
  },
  {
    id: 27,
    cover:
      "https://aleksandrachirtoska.com/img/projects/freight-solutions-brokerage.webp",
    title: "Freight Solutions Brokerage",
    categories: "Wordpress",
    liveUrl: "https://www.freightsolutionsbrokerage.com/",
    // githubUrl: "",
    technology: ["UX/UI", "Wordpress", "CSS3", "Elementor"],
    date: "Jan 2024",
    description:
      "A Freight Solutions Brokerage is a company for freight quotes and logistic. Complete project is Fullstuck with UX/UI design and Web Development",
    responsive: true,
  },
  {
    id: 26,
    cover:
      "https://aleksandrachirtoska.com/img/projects/the-movie-db-codecademy-project.webp",
    title: "The Movie DB Remake App",
    categories: "React",
    liveUrl: "https://movie-database-app-sepia.vercel.app/",
    githubUrl: "https://github.com/cirtoska/movie-database-app",
    technology: ["React", "TailWindCSS", "Redux", "API"],
    date: "Feb 2023",
    description:
      "My Final Project from CodeCademy - FrontEnd Engineer Path --- WORK STILL IN PROGRESS For this project, I will build an application using everything I’ve learned in this course. I choose to build a Movie App using the Movie Database API.",
    responsive: false,
  },
  {
    id: 25,
    cover: "https://aleksandrachirtoska.com/img/projects/best-todo-app.webp",
    title: "The Best Task Manager App",
    categories: "React",
    liveUrl: "https://grocery-list-zeta.vercel.app/",
    githubUrl: "https://github.com/cirtoska/best-todo-app",
    technology: ["React", "CSS3", "HTML5"],
    date: "Feb 2023",
    description:
      "The app have tasks listed by Name, Date and Status. Every task can be edited or delited. The list can be sorted by Name and Date and can be filtered by Status (Active, Completed or All)",
    responsive: true,
  },
  {
    id: 1,
    cover:
      "https://aleksandrachirtoska.com/img/projects/iwec-final-react-project.webp",
    title: "IWEC Academy Final React Project",
    categories: "React",
    liveUrl: "https://react-api-web-app.vercel.app/",
    githubUrl: "https://github.com/cirtoska/react-api-web-app",
    technology: ["React", "CSS", "Redux", "API"],
    date: "Sep 2022",
    description:
      "This was my final React project from IWEC Academy. I've used all skills that I've learned from IWEC. All is worked with functional components. I was using almost all APIs from https://dummyjson.com/; Login details fot the Login Page are username: kminchelle; password: 0lelplR",
    responsive: true,
  },
  {
    id: 2,
    cover:
      "https://aleksandrachirtoska.com/img/projects/codecademy-Challenge-Project-Responsive-Club-Website.webp",
    title: "Responsive Club Website",
    categories: "HTML/CSS",
    liveUrl:
      "https://cirtoska.github.io/Challenge-Project---Responsive-Club-Website/",
    githubUrl:
      "https://github.com/cirtoska/Challenge-Project---Responsive-Club-Website",
    technology: ["HTML5", "CSS3", "UX/UI"],
    date: "Aug 2022",
    description:
      "This projects was from Codecademy WEB DEVELOPMENT FOUNDATIONS. The task was to create a webpage for a local club. I've choose everything about this page: the club name, the logo, the page layout and styling, all the images I've used are from Unspalsh.",
    responsive: true,
  },
  {
    id: 3,
    cover:
      "https://aleksandrachirtoska.com/img/projects/codecademy-Challenge-Project-Responsive-Flexbox-Bussiness-Site.webp",
    title: "Responsive Flexbox Bussiness Site",
    categories: "HTML/CSS",
    liveUrl:
      "https://cirtoska.github.io/Chalenge-Project-Flexbox-business-site/",
    githubUrl:
      "https://github.com/cirtoska/Chalenge-Project-Flexbox-business-site",
    technology: ["HTML5", "CSS3", "UX/UI"],
    date: "Aug 2022",
    description:
      "This projects was from Codecademy WEB DEVELOPMENT FOUNDATIONS. The task was to create a company homepage. I've choose everything about this page: the title and logo, for the page layout and styling I was using flexbox, products section, company's employees, all the images I've used are from Unspalsh.",
    responsive: true,
  },
  {
    id: 4,
    cover:
      "https://aleksandrachirtoska.com/img/projects/freecodecamp-build-random-quote-machine.webp",
    title: "Build a Random Quote Machine",
    categories: "React",
    liveUrl: "https://random-quote-machine-five.vercel.app/",
    githubUrl: "https://github.com/cirtoska/random-quote-machine",
    technology: ["React", "CSS3", "UX/UI", "API"],
    date: "Aug 2022",
    description:
      "This projects was from freeCodeCamp Front End Development Libraries Projects. The task was to build a Random Quote Machine, I was using API from dummyjson.com",
    responsive: true,
  },
  {
    id: 5,
    cover:
      "https://aleksandrachirtoska.com/img/projects/freecodecamp-build-a-markdown-previewer.webp",
    title: "Build a Markdown Previewer",
    categories: "React",
    liveUrl: "https://freecodecamp-build-a-markdown-previewer.vercel.app/",
    githubUrl:
      "https://github.com/cirtoska/freecodecamp-build-a-markdown-previewer",
    technology: ["React", "CSS3", "UX/UI"],
    date: "Aug 2022",
    description:
      "This projects was from freeCodeCamp Front End Development Libraries Projects. The task was to build a Markdown Previewer. For the solution I was using react library 'react-markdown'.",
    responsive: true,
  },
  {
    id: 6,
    cover:
      "https://aleksandrachirtoska.com/img/projects/freecodecamp-javascript-calculator.webp",
    title: "Build a JavaScript Calculator",
    categories: "React",
    liveUrl: "https://free-code-camp-javascript-calculator-hoem.vercel.app/",
    githubUrl: "https://github.com/cirtoska/freeCodeCamp-javascript-calculator",
    technology: ["React", "CSS3"],
    date: "Sep 2022",
    description:
      "This projects was from freeCodeCamp Front End Development Libraries Projects. The task was to build a JavaScript Calculator. For the solution I was using react useState hook.",
    responsive: true,
  },
  {
    id: 7,
    cover:
      "https://aleksandrachirtoska.com/img/projects/freecodecamp-build-a-pomodoro-clock.webp",
    title: "Build a 25 + 5 Clock",
    categories: "React",
    liveUrl: "https://pomodoro-clock-ghsx.vercel.app/",
    githubUrl: "https://github.com/cirtoska/pomodoro-clock",
    technology: ["React", "CSS3", "UX/UI"],
    date: "Sep 2022",
    description:
      "This projects was from freeCodeCamp Front End Development Libraries Projects. The task was to build a 25 + 5 Clock, also known as Pomodoro Clock. For the solution I was using multiple react hooks.",
    responsive: true,
  },
  {
    id: 8,
    cover: "https://aleksandrachirtoska.com/img/projects/the-cocktail-db.webp",
    title: "The Cocktail DB",
    categories: "React",
    liveUrl: "https://the-cocktail-db-six.vercel.app/",
    githubUrl: "https://github.com/cirtoska/the-cocktail-db",
    technology: ["React", "CSS3", "API", "UX/UI", "Adobe XD"],
    date: "Aug 2022",
    description:
      "For this project the idea was to create a search cocktail database. First I've designed the app in Adobe XD and then I've developed the code in React using API from thecocktaildb.com",
    responsive: true,
  },
  {
    id: 9,
    cover:
      "https://aleksandrachirtoska.com/img/projects/github-users-react-app.webp",
    title: "Fetch Github Users with React",
    categories: "React",
    liveUrl: "https://calm-melba-838062.netlify.app/",
    githubUrl: "https://github.com/cirtoska/github-users",
    technology: ["React", "CSS3", "API"],
    date: "Jul 2022",
    description:
      "This project is just a list of github users using API from https://api.github.com/users. I was using react hooks for fetching the users from the API.",
    responsive: true,
  },
  {
    id: 10,
    cover: "https://aleksandrachirtoska.com/img/projects/movie-db-search.webp",
    title: "Movie Database",
    categories: "React",
    liveUrl: "https://movie-db-search.vercel.app/",
    githubUrl: "https://github.com/cirtoska/movie-db-search",
    technology: ["React", "CSS3", "API"],
    date: "Oct 2022",
    description:
      "This is Movie DB App for browsing movies. It's build with React using custom fetch hook and contex.",
    responsive: true,
  },
  {
    id: 11,
    cover:
      "https://aleksandrachirtoska.com/img/projects/freecodecamp-tribute-page.webp",
    title: "Tribute Page",
    categories: "HTML/CSS",
    liveUrl: "https://cirtoska.github.io/Tribute-Page/",
    githubUrl: "https://github.com/cirtoska/Tribute-Page",
    technology: ["HTML", "CSS3"],
    date: "May 2022",
    description:
      "This was the third Certification Project from freeCodeCamp Responsive Web Design. The task was to build a Tribute Page.",
    responsive: true,
  },
  {
    id: 12,
    cover:
      "https://aleksandrachirtoska.com/img/projects/freecodecamp-product-landing-page.webp",
    title: "Product Landing Page",
    categories: "HTML/CSS",
    liveUrl: "https://cirtoska.github.io/Product-landing-page/",
    githubUrl: "https://github.com/cirtoska/Product-landing-page",
    technology: ["HTML", "CSS3"],
    date: "Jun 2022",
    description:
      "This was the fourth Certification Project from freeCodeCamp Responsive Web Design. The task was to build a Product Landing Page.",
    responsive: true,
  },
  {
    id: 13,
    cover:
      "https://aleksandrachirtoska.com/img/projects/freecodecamp-personal-portfolio.webp",
    title: "freeCodeCamp Personal Portfolio",
    categories: "HTML/CSS",
    liveUrl: "https://free-code-camp-personal-portfolio.vercel.app/",
    githubUrl: "https://github.com/cirtoska/freeCodeCamp-Personal-Portfolio",
    technology: ["HTML", "CSS3"],
    date: "Aug 2022",
    description:
      "This was the last Certification Project from freeCodeCamp Responsive Web Design. The task was to build a freeCodeCamp Personal Portfolio.",
    responsive: true,
  },
  {
    id: 14,
    cover:
      "https://aleksandrachirtoska.com/img/projects/modern-registration-form.webp",
    title: "Modern Registration Form",
    categories: "HTML/CSS",
    liveUrl: "https://cirtoska.github.io/Modern-Registration-Form/",
    githubUrl: "https://github.com/cirtoska/Modern-Registration-Form",
    technology: ["HTML", "CSS3"],
    date: "Mar 2022",
    description:
      "This was IWEC Academy Project. The task was to create Modern Registration Form from image to HTML/CSS solution",
    responsive: true,
  },
  {
    id: 15,
    cover:
      "https://aleksandrachirtoska.com/img/projects/visual-studio-chalenge.webp",
    title: "IWEC Academy Visual Studio Project",
    categories: "HTML/CSS",
    liveUrl: "https://cirtoska.github.io/VS-Code-Project/",
    githubUrl: "https://github.com/cirtoska/VS-Code-Project",
    technology: ["HTML", "CSS3"],
    date: "Mar 2022",
    description:
      "This was IWEC Academy Project. The task was to create replica from the official VS Code (https://code.visualstudio.com/) website.",
    responsive: true,
  },
  {
    id: 16,
    cover: "https://aleksandrachirtoska.com/img/projects/tnw-exercise.webp",
    title: "IWEC Academy TheNextWeb Project",
    categories: "HTML/CSS",
    liveUrl: "https://cirtoska.github.io/TheNextWeb/",
    githubUrl: "https://github.com/cirtoska/TheNextWeb",
    technology: ["HTML", "CSS3"],
    date: "Mar 2022",
    description:
      "This was IWEC Academy Project. The task was to create replica from the official The Next Web (https://thenextweb.com/) website.",
    responsive: true,
  },
  // {
  //   id: 19,
  //   cover:
  //     "https://aleksandrachirtoska.com/img/projects/javascript-fetch-countries.webp",
  //   title: "Country Cards - Fetching Data with JS IWEC Academy exercise",
  //   categories: "JavaScript",
  //   liveUrl: "https://cirtoska.github.io/Country-Cards/",
  //   githubUrl: "https://github.com/cirtoska/Country-Cards",
  // },
  {
    id: 17,
    cover:
      "https://aleksandrachirtoska.com/img/projects/frontend-mentor-loopstudios.webp",
    title: "Loopstudios landing page",
    categories: "HTML/CSS",
    liveUrl:
      "https://cirtoska.github.io/frontend-mentor-loopstudios-landing-page-main/",
    githubUrl:
      "https://github.com/cirtoska/frontend-mentor-loopstudios-landing-page-main",
    technology: ["HTML", "CSS3", "JavaScript"],
    date: "Oct 2022",
    description:
      "This challenge from Frontend Mentor focuses mostly on HTML & CSS. There's a tiny bit of JS included for the mobile navigation toggle.",
    responsive: true,
  },

  {
    id: 18,
    cover:
      "https://aleksandrachirtoska.com/img/projects/frontend-mentor-chalenge-card.webp",
    title: "NFT preview card component",
    categories: "HTML/CSS",
    liveUrl: "https://cirtoska.github.io/nft-preview-card-component-main/",
    githubUrl: "https://github.com/cirtoska/nft-preview-card-component-main",
    technology: ["HTML", "CSS3"],
    date: "Mar 2022",
    description:
      "This challenge from Frontend Mentor was to build out preview card component and get it looking as close to the design as possible.",
    responsive: true,
  },
  {
    id: 19,
    cover:
      "https://aleksandrachirtoska.com/img/projects/frontend-mentor-chalenge-grid-chalenge.webp",
    title: "Testimonials grid section",
    categories: "HTML/CSS",
    liveUrl: "https://cirtoska.github.io/testimonials-grid-section-main/",
    githubUrl: "https://github.com/cirtoska/testimonials-grid-section-main",
    technology: ["HTML", "CSS3"],
    date: "Mar 2022",
    description:
      "This challenge from Frontend Mentor was to build out testimonials grid section and get it looking as close to the design as possible.",
    responsive: true,
  },
  {
    id: 20,
    cover:
      "https://aleksandrachirtoska.com/img/projects/frontend-mentor-chalenge-2.webp",
    title: "Huddle landing page with curved sections",
    categories: "HTML/CSS",
    liveUrl:
      "https://cirtoska.github.io/huddle-landing-page-with-curved-sections-master/",
    githubUrl:
      "https://github.com/cirtoska/huddle-landing-page-with-curved-sections-master",
    technology: ["HTML", "CSS3"],
    date: "Mar 2022",
    description:
      "This challenge from Frontend Mentor was to build out landing page and get it looking as close to the design as possible.",
    responsive: true,
  },
  {
    id: 21,
    cover:
      "https://aleksandrachirtoska.com/img/projects/frontend-mentor-chalenge3.webp",
    title: "Fylo landing page with two column layout",
    categories: "HTML/CSS",
    liveUrl:
      "https://cirtoska.github.io/fylo-landing-page-with-two-column-layout-master/",
    githubUrl:
      "https://github.com/cirtoska/fylo-landing-page-with-two-column-layout-master",
    technology: ["HTML", "CSS3"],
    date: "Mar 2022",
    description:
      "This challenge from Frontend Mentor was to build out landing page and get it looking as close to the design as possible.",
    responsive: true,
  },
];
